import styled from "@emotion/styled";
import { Col, Row } from "antd";

export const MainMenuItem = styled(Row)`
  color: ${(props) => props.theme.color.white};
  cursor: pointer;
  margin-bottom: ${(props) => props.theme.spacing.regular};
  &:first-of-type {
    margin-top: ${(props) => props.theme.spacing.xxxl};
  }
`;

export const MenuItemContainer = styled(Col)`
  border-radius: 40px;
  transition: ${(props) =>
    props.isActive ? "background-color 1s cubic-bezier(0,0,0.58,1)" : "none"};
  background-color: ${(props) =>
    props.isActive ? props.theme.color.white : props.theme.color.primary};
  color: ${(props) =>
    props.isActive ? props.theme.color.primary : props.theme.color.white};
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 124px;
  width: 90px;
  text-align: center;
`;

export const MenuItemIcon = styled.img`
  display: block;
  margin: 0 auto;
  width: 32px;
  height: 32px;
`;

export const MenuItemLabel = styled.p`
  font-size: 16px;
  margin-top: ${(props) => props.theme.spacing.xxs};
  transition: none;
`;
